/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CreateClaimRequestInput = {
    readonly clientMutationId: string;
    readonly descriptions?: string | null;
    readonly item: string;
    readonly personEmail: string;
    readonly previews?: ReadonlyArray<CreatePreviewInput> | null;
};
export type CreatePreviewInput = {
    readonly kind?: ReadonlyArray<string> | null;
    readonly link?: string | null;
    readonly mediaAsset?: string | null;
};
export type createClaimRequestMutationVariables = {
    readonly input: CreateClaimRequestInput;
};
export type createClaimRequestMutationResponse = {
    readonly createClaimRequest: {
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly userRequest: ({
            readonly id?: string;
            readonly description?: string | null;
            readonly expired?: unknown | null;
            readonly personEmail?: string | null;
            readonly kind?: string | null;
            readonly revision?: string | null;
        } & ({
            readonly id: string;
            readonly description: string | null;
            readonly expired: unknown | null;
            readonly personEmail: string | null;
            readonly kind: string | null;
            readonly revision: string | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type createClaimRequestMutation = {
    readonly response: createClaimRequestMutationResponse;
    readonly variables: createClaimRequestMutationVariables;
};



/*
mutation createClaimRequestMutation(
  $input: CreateClaimRequestInput!
) {
  createClaimRequest(input: $input) {
    errors {
      id
      location
    }
    hasErrors
    userRequest {
      __typename
      ... on ClaimRequest {
        id
        description
        expired
        personEmail
        kind
        revision
      }
      ... on UGCRequest {
        id
        description
        revision
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateClaimRequestInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expired",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "personEmail",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "createClaimRequestMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createClaimRequest",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateUpdateUserRequestPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userRequest",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "ClaimRequest",
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "UGCRequest",
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "createClaimRequestMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createClaimRequest",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateUpdateUserRequestPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userRequest",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "ClaimRequest",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "UGCRequest",
                "selections": [
                  (v5/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "createClaimRequestMutation",
    "id": null,
    "text": "mutation createClaimRequestMutation(\n  $input: CreateClaimRequestInput!\n) {\n  createClaimRequest(input: $input) {\n    errors {\n      id\n      location\n    }\n    hasErrors\n    userRequest {\n      __typename\n      ... on ClaimRequest {\n        id\n        description\n        expired\n        personEmail\n        kind\n        revision\n      }\n      ... on UGCRequest {\n        id\n        description\n        revision\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '44329810d8a3eeab1cd48a86794bdbcd';
export default node;
